import { DestinationAccountControllerType } from "../useDestinationAccount";

import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";

import { TileContainer } from "./styles";
import { BodyLargeRegular, TitleLarge } from "../../../components/font";
import { OptionTile } from "@manifesthhqinc/ui-library";
import { STEP_DESTINATION_CONNECT_ES, STEP_DESTINATION_CONNECT_IRA } from "../../../class/transferDetails";
import HeadingContainer from "../../../layout/heading-container";

const DestinationOptionType = (props: DestinationAccountControllerType) => {
  const { goToDestinationScreen, setIsEmployerSponsored } = props;
  return (
    <TransitionWrapper>
      <ScrollableContainer name="confirm-destination-account">
        <Container>
          <HeadingContainer paneVariant="optionForm" withProgressBar>
            <TitleLarge $textAlign="left">What type of account is it?</TitleLarge>
            <BodyLargeRegular>
              Add an IRA or an employer-sponsored plan, e.g., 401(k), 403(b), 457(b), TSP.
            </BodyLargeRegular>
          </HeadingContainer>
          <TileContainer $flexDirection="column" $width="100%">
            <OptionTile
              variant="clickthrough"
              appearance="secondary"
              onClick={() => {
                setIsEmployerSponsored(false);
                goToDestinationScreen(STEP_DESTINATION_CONNECT_IRA);
              }}
              name="ira"
            >
              IRA
            </OptionTile>
            <OptionTile
              variant="clickthrough"
              appearance="secondary"
              onClick={() => {
                setIsEmployerSponsored(true);
                goToDestinationScreen(STEP_DESTINATION_CONNECT_ES);
              }}
              name="esplan"
            >
              Employer Plan
            </OptionTile>
          </TileContainer>
        </Container>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};

export default DestinationOptionType;
